import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useCreateKey = (projectId, version) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();
  return useMutation(
    async ({ name, translations }) => {
      const { data } = await fetchContext.authAxios.post(
        `/projects/${projectId}/versions/${version}/keys`,
        [
          {
            name,
            translations,
          },
        ]
      );
      return data;
    },
    {
      onSettled(data) {
        const queryKey = [
          "project",
          projectId,
          "version",
          version?.toString(),
          "keys",
        ];
        queryClient
          .getQueryCache()
          .findAll(queryKey)
          .forEach(({ queryKey }) => {
            const previousKeys = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, [...data, ...previousKeys]);
          });
      },
    }
  );
};
